module.exports = "query PimProductsProvidersSelectQuery{providers{edges{node{value:prologueId label:title}}}}"